import { Component, signal } from '@angular/core';
import { IIssueTrackingStats, IssueTrackingService } from 'app/shared/issue-tracking.service';

@Component({
  selector: 'app-issue-tracking-stats',
  standalone: false,
  templateUrl: './issue-tracking-stats.component.html',
  styleUrl: './issue-tracking-stats.component.css'
})
export class IssueTrackingStatsComponent {

  stats = signal<IIssueTrackingStats>(null);

  constructor(private issueTrackingService: IssueTrackingService) {
    issueTrackingService.getStats().then(stats => {
      if (stats) {
        this.stats.set(stats);
      }
    });
  }
}
